module.exports = __webpack_public_path__ + "static/img/davis_pictgrid45_920x864.15bec44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid45_920x864.jpg
// module id = n+mf
// module chunks = 0